import axios from 'axios';

export default (language: string): void => {
  axios.defaults.headers.common['Accept-Language'] = language;
};
